import script from "./FormKitDemos.vue?vue&type=script&setup=true&lang=js"
export * from "./FormKitDemos.vue?vue&type=script&setup=true&lang=js"

import "./FormKitDemos.vue?vue&type=style&index=0&id=65e0973c&lang=css"

const __exports__ = script;

export default __exports__